import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { BaseApiResponse } from '@/types/api/api-v2';
import { AuthResult } from '@/types/api/auth';

export default async function doSignUp(
  email: string,
  password: string,
  firstName: string,
  lastName: string,
  locale: string,
  captcha: string
) {
  try {
    const {
      data: { data },
    } = await spiritoryWebApi.post<BaseApiResponse<AuthResult>>(
      '/auth/sign-up/credentials',
      {
        email: email,
        password: password,
        firstName: firstName,
        lastName: lastName,
        captcha: captcha,
        locale: locale,
      },
      undefined
    );

    return data;
  } catch (err) {
    throw err;
  }
}
